module.exports = __webpack_public_path__ + "static/media/union.5fcff47c.svg";